import React from "react";
import { Helmet } from "react-helmet-async";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
// import RelatedBlogs from "../../components/Blogs/RelatedBlogs/RelatedBlogs";
// import Ads from "../../components/Ads/Ads";
import "./SiteMaps.css";

/* ─── Small inline icons ─────────────────────────────────────────────── */
const IconHome = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);
const IconLayers = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" />
  </svg>
);
// const IconBuilding = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="4" y="2" width="16" height="20" rx="1" /><line x1="9" y1="6" x2="9" y2="6.01" /><line x1="15" y1="6" x2="15" y2="6.01" />
//     <line x1="9" y1="10" x2="9" y2="10.01" /><line x1="15" y1="10" x2="15" y2="10.01" /><line x1="9" y1="14" x2="9" y2="14.01" /><line x1="15" y1="14" x2="15" y2="14.01" />
//   </svg>
// );
const IconScale = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="3" x2="12" y2="21" /><path d="M5 8l-3 6a4 4 0 0 0 6 0z" /><path d="M19 8l-3 6a4 4 0 0 0 6 0z" /><path d="M5 8h14" /><path d="M9 21h6" />
  </svg>
);
const IconUser = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
  </svg>
);

interface LinkItem { to: string; label: string; }
interface Group { icon: React.ReactNode; title: string; desc: string; links: LinkItem[]; }

const GROUPS: Group[] = [
  {
    icon: <IconHome />, title: "Main Pages", desc: "Core pages of the platform.",
    links: [
      { to: "/", label: "Home" },
      { to: "/about-us", label: "About Us" },
      { to: "/contact-us", label: "Contact Us" },
      { to: "/site-maps", label: "Site Map" },
    ],
  },
  {
    icon: <IconLayers />, title: "Learn & Practice", desc: "Test series, MCQs and blog content.",
    links: [
      { to: "/online-test-series", label: "Online Test Series" },
      { to: "/blogs/all-blogs/mcqs", label: "MCQ Practice" },
      { to: "/blogs/all-blogs/posts", label: "Blog Posts" },
      { to: "/blogs/all-blogs/technical_posts", label: "Technical Posts" },
      { to: "/blogs/all-blogs/interview_questions", label: "Interview Questions" },
    ],
  },
  {
    icon: <IconUser />, title: "Account", desc: "Manage your Acadebility account.",
    links: [
      { to: "/login", label: "Sign In" },
      { to: "/register", label: "Sign Up" },
    ],
  },
  {
    icon: <IconScale />, title: "Legal", desc: "Policies governing use of the platform.",
    links: [
      { to: "/terms-and-conditions", label: "Terms & Conditions" },
      { to: "/privacy-policy", label: "Privacy Policy" },
      { to: "/disclaimer", label: "Disclaimer" },
    ],
  },
];

const SiteMaps = () => {
  return (
    <>
      <Helmet>
        <title>Acadebility - Site Map</title>
        <meta name="description" content="Browse every page on Acadebility — test series, MCQ practice, blogs, account pages and policies, all in one place." />
      </Helmet>

      <div className="lgl-page sm-page">
        {/* ── Hero ── */}
        <div className="lgl-hero">
          <div className="lgl-hero-inner">
            <nav className="lgl-breadcrumb">
              <Link to="/">Home</Link>
              <span className="lgl-sep">/</span>
              <span className="lgl-crumb-current">Site Map</span>
            </nav>
            <h1 className="lgl-title">Site Map</h1>
            <p className="lgl-subtitle">
              A complete, organized index of every page on Acadebility — jump straight to what you're looking for.
            </p>
          </div>
        </div>

        {/* ── Body ── */}
        <div className="lgl-body">
          <div className="lgl-body-inner">
            <div className="lgl-layout">

              <main className="lgl-content sm-content">
                {GROUPS.map(group => (
                  <div className="sm-group" key={group.title}>
                    <div className="sm-group-head">
                      <div className="sm-group-icon">{group.icon}</div>
                      <div>
                        <h2 className="sm-group-title">{group.title}</h2>
                        <p className="sm-group-desc">{group.desc}</p>
                      </div>
                    </div>
                    <ul className="sm-link-list">
                      {group.links.map(l => (
                        <li key={l.to}>
                          <Link to={l.to}>{l.label}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </main>

              {/* <aside className="lgl-sidebar">
                <div className="lgl-sidebar-card">
                  <Ads slot="6292270820" style={{ display: "block" }} />
                </div>
                <div className="lgl-sidebar-card">
                  <RelatedBlogs />
                </div>
              </aside> */}

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SiteMaps;